import { TRACKERS } from "@/constants/Trackers";
import { FilesWithProvider } from "@/features/Patient/MedicalRecords/Files";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/files")({
  component: FilesWithProvider,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_FILES);
  },
});
